import React from 'react';

import { PulseLoader } from 'react-spinners';
import styles from './style.module.scss';

interface LoadingOverlayProps {
  loading: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading }) => {
  if (!loading) return null;

  return (
    <>
      {loading && (
        <div className={styles.blurOverlay}>
          <div className={styles.spinnerContainer}>
            <PulseLoader size={15} color="#4a4a4a" />
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingOverlay;
